import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { BadgeWrapper, BadgeDot } from './Badge.styles.js';
import Typography from '../Typography/Typography.js';

const Badge = forwardRef((props, ref) => {
    const { text, id, onClick, type = "default", showDot = false, borderRadius, fillType = "contained", transparent, underline = false, fontSize, mFontSize, leftNode = null, } = props;
    return (jsxs(BadgeWrapper, Object.assign({ onClick: onClick, type: type, id: id, borderRadius: borderRadius, fillType: fillType, transparent: transparent }, { children: [showDot ? jsx(BadgeDot, {}) : null, leftNode, jsx(Typography, Object.assign({ weight: "medium", size: fontSize || "s", mSize: mFontSize || "xs", align: "center", noWrap: true, underline: underline }, { children: text }))] })));
});

export { Badge as default };
//# sourceMappingURL=Badge.js.map
